import { doc, runTransaction, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { MY_COMPANY_PROJECT_ID } from "./projectVisibility";

// Ett fast dokument-id gör att Mitt företag alltid uppdaterar samma projekt.
export const MY_COMPANY_ID = MY_COMPANY_PROJECT_ID;

export async function saveMyCompany(companyAccountUid, form) {
  if (!companyAccountUid || !form.projectName.trim()) {
    throw new Error("Fyll i projektnamn.");
  }
  const accountRef = doc(db, "users", companyAccountUid);
  const projectRef = doc(db, "users", companyAccountUid, "projects", MY_COMPANY_ID);

  await runTransaction(db, async transaction => {
    const account = await transaction.get(accountRef);
    const project = await transaction.get(projectRef);
    if (account.data()?.myCompany !== true) {
      throw new Error("Mitt företag är inte aktiverat för detta företagskonto.");
    }
    const updatedAt = serverTimestamp();
    transaction.set(projectRef, {
      name: form.projectName.trim(),
      area: form.area.trim(),
      description: form.description.trim(),
      active: true,
      updatedAt,
      ...(!project.exists() ? { createdAt: updatedAt, customerId: "", customerName: "" } : {}),
    }, { merge: true });
  });
}
